import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    redirect: '/index',

  },
  {
    path: '/index',
    name: 'index',
    meta: {
      footshow: false,
    },
    nameTxt: '首页',
    component: () => import('../views/index.vue')
  },
  {
    path: '/booksearch',
    name: 'booksearch',
    meta: {
      footshow: true,
    },
    nameTxt: '搜索结果',
    component: () => import('../views/booksearch.vue')
  },
  {
    path: '/about',
    name: 'about',
    meta: {
      footshow: true,
    },
    nameTxt: '关于我们',
    component: () => import('../views/about.vue')
  },
  {
    path: '/noticelist',
    name: 'noticelist',
    meta: {
      footshow: true,
    },
    nameTxt: '公告',
    component: () => import('../views/noticelist.vue')
  },
  {
    path: '/noticedetail',
    meta: {
      footshow: true,
    },
    name: 'noticedetail',

    component: () => import('../views/noticedetail.vue')
  },
  {
    path: '/newslist',
    meta: {
      footshow: true,
    },
    name: 'newslist',
    nameTxt: '新闻',
    component: () => import('../views/newslist.vue')
  },
  {
    path: '/recruitdetail',
    meta: {
      footshow: true,
    },
    name: 'recruitdetail',
    component: () => import('../views/noticedetail.vue')
  },
  {
    path: '/books',
    meta: {
      footshow: true,
    },
    name: 'books',
    nameTxt: '图书',
    component: () => import('../views/books.vue')
  },
  {
    path: '/booklist',
    meta: {
      footshow: true,
    },
    name: 'booklist',
    component: () => import('../views/booklist.vue')
  },
  {
    path: '/bookdetail',
    meta: {
      footshow: true,
    },
    name: 'bookdetail',
    component: () => import('../views/bookdetail.vue')
  },
  {
    path: '/bookdownload',
    meta: {
      footshow: true,
    },
    name: 'bookdownload',
    component: () => import('../views/bookdownload.vue')
  },
  {
    path: '/bookrequest',
    meta: {
      footshow: true,
    },
    name: 'bookrequest',
    component: () => import('../views/bookrequest.vue')
  },
  {
    path:'/thinkTank',
    meta: {
      footshow: true,
    },
    name: 'thinkTank',
    component: () => import('../views/thinkTank.vue')
  },
  {
    path:'/cooperation',
    meta: {
      footshow: true,
    },
    name: 'cooperation',
    component: () => import('../views/cooperation.vue')
  },
  {
    path:'/contentus',
    meta: {
      footshow: true,
    },
    name: 'contentus',
    component: () => import('../views/contentus.vue')
  },
  {
    path:'/leadershipCare',
    meta: {
      footshow: true,
    },
    name: 'leadershipCare',
    component: () => import('../views/leadershipCare.vue')
  },
  {
    path:'/businessReading',
    meta: {
      footshow: true,
    },
    name: 'businessReading',
    nameTxt: '商务阅读平台',
    component: () => import('../views/businessReading.vue')
  },
  {
    path:'/pdfSearch',
    meta: {
      footshow: true,
    },
    name: 'pdfSearch',
    nameTxt: 'PDF搜索结果',
    component: () => import('../views/pdfSearch.vue')
  },
  {
    path:'/pdfList',
    meta: {
      footshow: true,
    },
    name: 'pdfList',
    nameTxt:'PDF文档推荐',
    component: () => import('../views/pdfList.vue')
  }
]

const router = new VueRouter({
  mode:'hash',
  scrollBehavior: () => ({
    y: 0
  }),
  routes
})

const originalPush = VueRouter.prototype.push
  VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router